import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import * as moment from "moment";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
export default class LiveNewsPresenter {
    constructor(actions, usecase, useCasesStream, useCasesNewsStream) {
        this.actions = actions;
        this.usecase = usecase;
        this.useCasesStream = useCasesStream;
        this.useCasesNewsStream = useCasesNewsStream;
        this.liveNews = {
            content: [],
            number: 0,
            size: 0,
            totalElements: 0,
            totalPages: 0,
        };
        this.symbols = [];
    }
    getLiveNewsData(requestData) {
        this.actions.hideError();
        this.actions.setStartLiveNewsLoader();
        const newsPayload = {
            segmentType: requestData === null || requestData === void 0 ? void 0 : requestData.segmentType,
            exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory) ? requestData.exclCategory : [],
            validRequest: false,
            inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory)
                ? requestData.inclCategory
                : ["Default"],
            page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
            searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
        };
        this.usecase.liveNews.execute({
            onSuccess: (data) => {
                if (data.content.length > 0 && (requestData === null || requestData === void 0 ? void 0 : requestData.page) > 0) {
                    this.liveNews.content = [...this.liveNews.content, ...data.content];
                    this.liveNews.number = data.number;
                    this.liveNews.totalPages = data.totalPages;
                    this.liveNews.totalElements = data.totalElements;
                    this.liveNews.size = data.size;
                }
                else
                    this.liveNews = data;
                data.content.map((news) => {
                    var _a;
                    (_a = news.customElements) === null || _a === void 0 ? void 0 : _a.map((z) => {
                        if (z.sym !== "" && !this.symbols.includes(z.sym))
                            this.symbols.push(z.sym);
                    });
                });
                this.actions.getLiveNewsData(this.liveNews);
                this.actions.setStopLiveNewsLoader();
                this.getNewsQouteStreamData(true);
            },
            onError: (error) => {
                this.actions.setStopLiveNewsLoader();
                this.actions.setError({ isOpen: true, error });
            },
        }, newsPayload);
    }
    getEquityHoldingLiveNews(requestData) {
        this.actions.hideError();
        this.actions.setStartLiveNewsLoader();
        const newsPayload = {
            exclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.exclCategory) ? requestData.exclCategory : [],
            validRequest: false,
            inclCategory: (requestData === null || requestData === void 0 ? void 0 : requestData.inclCategory)
                ? requestData.inclCategory
                : ["Default"],
            page: requestData === null || requestData === void 0 ? void 0 : requestData.page,
            searchText: requestData === null || requestData === void 0 ? void 0 : requestData.searchText,
        };
        this.usecase.equityHoldingLiveNews.execute({
            onSuccess: (data) => {
                if (data.content.length > 0 && requestData.page > 0) {
                    this.liveNews.content = [...this.liveNews.content, ...data.content];
                    this.liveNews.number = data.number;
                    this.liveNews.totalPages = data.totalPages;
                    this.liveNews.totalElements = data.totalElements;
                    this.liveNews.size = data.size;
                }
                else
                    this.liveNews = data;
                data.content.map((news) => {
                    var _a;
                    (_a = news.customElements) === null || _a === void 0 ? void 0 : _a.map((z) => {
                        if (z.sym !== "" && !this.symbols.includes(z.sym))
                            this.symbols.push(z.sym);
                    });
                });
                this.actions.getEquityHoldingLiveNews(this.liveNews);
                this.actions.setStopLiveNewsLoader();
                this.getNewsQouteStreamData(true);
            },
            onError: (error) => {
                this.actions.setStopLiveNewsLoader();
                this.actions.setError({ isOpen: true, error });
            },
        }, newsPayload);
    }
    getNewsQouteStreamData(subscribe) {
        const symb = this.symbols;
        const streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
        ];
        if (symb.length > 0)
            this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
                if (symb.includes(mappedData.symbol)) {
                    this.actions.getNewsStreamData(mappedData);
                }
            }, symb, streamMapKey);
    }
    getLiveNewsStreaming(subscribe) {
        setTimeout(() => {
            this.useCasesNewsStream.streamQuote(STREAMING_TYPE.NEWS, subscribe, async (mappedData) => {
                var _a;
                if (mappedData.hasOwnProperty("customElements") &&
                    ((_a = mappedData === null || mappedData === void 0 ? void 0 : mappedData.customElements) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    !this.symbols.includes(mappedData.customElements[0].sym)) {
                    this.symbols.push(mappedData.customElements[0].sym);
                }
                mappedData.timeText = moment(mappedData.timeText).fromNow();
                this.actions.getLiveNewsStreamData(mappedData);
            });
        }, 100);
    }
    resetCount() {
        this.actions.resetCount();
    }
}
